export default {
 bottom:true,//展示底部导航栏

}
